import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=7cc774c8"
import script from "./ChangePwd.vue?vue&type=script&lang=js"
export * from "./ChangePwd.vue?vue&type=script&lang=js"
import style0 from "./ChangePwd.vue?vue&type=style&index=0&id=7cc774c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports